import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { environment } from '@env/environment';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { AppSettingsService } from '@core/services/app-settings.service';
import { CoreModule } from '@core/core.module';
import { AppService } from './app.service';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

@NgModule({
  declarations: [AppComponent],
  imports: [
    AppRoutingModule,
    CommonModule,
    CoreModule,
    ...(environment.production ? [] : [NgxsReduxDevtoolsPluginModule.forRoot()]),
  ],
  providers: [AppService, AppSettingsService],
  bootstrap: [AppComponent],
})
export class AppModule {}
